import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
import FileSaver from 'file-saver';
import T from "i18n-react";

class InvoiceService {

    downloadInvoice(invoiceId) {
        let url = '/api/invoice/' + invoiceId + '/file'

        return WebService.downloadFile(url, HttpMethods.GET, function (blob, fileName) {
                FileSaver.saveAs(blob, fileName);
        })
    }

    getInvoiceFileApiUrl(invoiceId) {
        return '/api/invoice/' + invoiceId + '/file';
    }

    checkInvoice(invoiceId) {
        let url = '/api/invoice/' + invoiceId + '/check';
        return WebService.call(url, HttpMethods.GET);
    }

    /**
     * Récupère la liste paginée pour la page des factures
     */
    getInvoiceList(page, size = 0, location, client, bu, periodYear, periodMonthList, search) {
        let url = `/api/invoice?page=${page-1}&size=${size}`;
        url += location ? `&location=${location}` : '';
        url += client ? `&client=${client}` : '';
        url += bu ? `&bu=${bu}` : '';
        url += periodYear ? `&periodYear=${periodYear}` : '';
        if(periodMonthList && periodMonthList.length > 0) {
            periodMonthList.forEach(periodMonth => {
                url += `&periodMonthList=${periodMonth}`;
            })
        }
        url += search ? `&search=${search}` : '';
        return WebService.call(url, HttpMethods.GET, null);
    }

    getCsvHeaderLabelList() {
        return [
            T.translate('tableFields.invoiceNumber'),
            T.translate('tableFields.clientName'),
            T.translate('tableFields.codeClient'),
            T.translate('tableFields.buName'),
            T.translate('tableFields.codeBu'),
            T.translate('tableFields.period'),
            T.translate('tableFields.amount')
        ];
    }

    formatInvoiceListForCsv(invoiceList) {
        const invoiceDataList = []
        invoiceList.forEach(invoice => {
            invoiceDataList.push(
                [
                    invoice.invoiceNumber || '' ,
                    invoice.clientName || '',
                    invoice.codeClient || '',
                    invoice.buName || '',
                    invoice.codeBu || '',
                    this.getFormattedPeriod(invoice.period, "-") || '',
                    this.getAmountString(invoice.amount, false) ? this.getAmountString(invoice.amount, false).replace(',','.') : ''
                ]);
        })
        return invoiceDataList;
    }

    getFormattedPeriod(period, delimiter) {
        if(period && period.monthValue && period.year) {
            return String(period.monthValue).padStart(2, '0') + delimiter + period.year;
        } else {
            return null
        }
    }

    getAmountString(amount, signed) {
        //Si 'signed' est vraie, on ajoute le signe
        return typeof amount === "number" ? (((amount > 0 && signed) ? '+ ' : '') + amount.toPrice()) : null;
    }

    getPdfViewerTitle(invoice) {
        if(invoice && invoice.invoiceNumber) {
            return T.translate('invoicePage.pdfViewer.title') + " N° " + invoice.invoiceNumber;
        } else {
            return T.translate('invoicePage.pdfViewer.title')
        }
    }
}

export default new InvoiceService();


// WEBPACK FOOTER //
// ./src/services/InvoiceService.js